import { render, staticRenderFns } from "./ControleDetailModal.vue?vue&type=template&id=01b958fc"
import script from "./ControleDetailModal.vue?vue&type=script&lang=ts"
export * from "./ControleDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports